import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import {
  GetCommunityFeedBySymbolParams,
  GetCommunityFeedBySymbolResponse,
  GetCommunityOnboardingResponse,
  GetCommunityPublicFeedParams,
  GetCommunityPublicFeedResponse,
  GetCommunityReferralParams,
  GetCommunityReferralResponse,
  GetLastTradeInfoResponse,
  GetTranslatedCommunityFeedParams,
  GetTranslatedCommunityFeedResponse,
  PatchCommunityFeedParams,
  PostCommunityFeedParams,
  PostCommunityFeedReactionParams,
  PostCommunityFeedReportParams,
} from './types';

export const getCommunityFeedsBySymbolApi = (symbol: string, params: GetCommunityFeedBySymbolParams) =>
  apiClient.get<GetCommunityFeedBySymbolResponse>(`/v1/community/${symbol}/feeds`, { params });

export const getCommunityPublicFeedsApi = (symbol: string, params: GetCommunityPublicFeedParams) =>
  apiClient.get<GetCommunityPublicFeedResponse>(`/v1/community/${symbol}/feeds-public`, { params });

export const getLastTradeInfoApi = (symbol: string) =>
  apiClient.get<GetLastTradeInfoResponse>(`/v1/community/${symbol}/feeds/last-trade`);

export const postCommunityFeedItemApi = (symbol: string, data: PostCommunityFeedParams) =>
  apiClient.post(`/v1/community/${symbol}/feeds`, data);

export const patchCommunityFeedItemApi = (symbol: string, feedId: string, data: PatchCommunityFeedParams) =>
  apiClient.patch(`/v1/community/${symbol}/feeds/${feedId}`, data);

export const deleteCommunityFeedItemApi = (symbol: string, feedId: string) =>
  apiClient.delete(`/v1/community/${symbol}/feeds/${feedId}`);

export const getTranslatedCommunityFeedApi = (
  symbol: string,
  feedId: string,
  params: GetTranslatedCommunityFeedParams,
) =>
  apiClient.get<GetTranslatedCommunityFeedResponse>(`/v1/community/${symbol}/feeds/${feedId}/translated`, { params });

export const postCommunityFeedReportApi = (symbol: string, feedId: string, data: PostCommunityFeedReportParams) =>
  apiClient.post(`/v1/community/${symbol}/feeds/${feedId}/report`, data);

export const fetchCommunityReferralApi = (params: GetCommunityReferralParams) =>
  fetchClient.fetch<GetCommunityReferralResponse>('/v1/community/referral', {
    params: { campaignName: params.campaignName },
  });

export const postCommunityFeedReactionApi = (symbol: string, feedId: string, data: PostCommunityFeedReactionParams) =>
  apiClient.post(`/v1/community/${symbol}/feeds/${feedId}/react`, data);

export const getCommunityReferralApi = (params?: GetCommunityReferralParams) =>
  apiClient.get<GetCommunityReferralResponse>('/v1/community/referral', { params });

// onboarding
export const getCommunityOnboardingApi = () =>
  apiClient.get<GetCommunityOnboardingResponse>('/v1/community/onboarding');

export const postCommunityOnboardingMarkApi = () => apiClient.post('/v1/community/onboarding/view');
